<div class="steps" (click)="act($event)"  [ngClass]="{'has_action':key && !isLoading, 'active': !isComplete, 'loading': isLoading }">
    <div class="step-info-wrapper">
        <div class="verification" [ngClass]="{ 'verified': isComplete }" [ngStyle]="{'background-color':isComplete?color:incompleteColor, 'border-color':isComplete?color:incompleteColor}">
            <mat-icon class="check-icon" *ngIf="!isLoading">check</mat-icon>
            <mat-spinner *ngIf="isLoading" diameter="16"></mat-spinner>
        </div>
        <span class="step-label">
            {{title}}
        </span>
    </div>
    <div class="actions-wrap" *ngIf="!isComplete && !isLoading">
        <button *ngIf="skipTitle" class="skip-button" (click)="skip($event)">{{skipTitle}}</button>
    </div>
    <div class="actions-wrap" *ngIf="isLoading">
        <span class="loading-text">Enviando...</span>
    </div>
</div>